import { Either } from 'monet';
import LeftResponse from '@/storage/LeftResponse';

/**
 * @description Шлюз активации пользователя.
 * @param {Axios} axios
 */
export default function ActivateGateway(axios) {
  /**
   * @description Отправить запрос на активацию.
   * @param {number} userId Идентификатор пользователя.
   * @param {any} request Запрос.
   * @returns {Promise<Either>}
   */
  this.activate = (userId, request) => axios
    .put(`/api/users/${userId}/activate`, request)
    .then(
      async (response) => Either.right(response.data),
      async (error) => {
        if (error.isAxiosError && [400, 404, 429].includes(error.response.status)) {
          const causes = error.response.data.causes || [];
          const { title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.left(leftResponse);
        }
        throw error;
      },
    );
}
